import { TransferPanel } from "src/components/Form/panels/TransferPanel/TransferPanel.tsx";
import React from "react";

import { useResourceFormContext } from "src/components/Form/hooks/useResourceFormContext.ts";

type TransferPanelV2Props = {
  mainResource?: string;
  transferResource: string;
};

export function TransferPanelV2(props: TransferPanelV2Props) {
  const { mainResource: mainResourceProp, transferResource } = props;

  const formContext = useResourceFormContext();

  const mainResource = mainResourceProp ?? formContext.resource;

  return (
    <TransferPanel formResource={mainResource} resource={transferResource} />
  );
}
